import {SearchRequest} from '../models/search/search.request.model';

export namespace Search {
  export class SearchJobs {
    static readonly type = '[Search api] Search Jobs';

    constructor(public searchRequest: SearchRequest) {
    }
  }

  export class ClearSearch {
    static readonly type = '[Search api] Clear Search';

    constructor() {
    }
  }
}
